import BaseModuleMixin from '@/app/shared/mixins/BaseModuleMixin';
import BasePermissionsMixin from '@/app/shared/mixins/BasePermissionsMixin';
import { apiConstants } from '../config';

export default {
    mixins: [
        BaseModuleMixin,
        BasePermissionsMixin,
    ],
    computed: {
        moduleInternalCode() {
            return apiConstants.code;
        },
    },
    methods: {
    },
};
